import { StagesService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';

export function useUnscopedStages({
  workflowId,
  perPage = 300,
  query,
  clonable = false,
}: {
  workflowId?: string;
  perPage?: number;
  query?: string;
  clonable?: boolean;
}) {
  const fetchStages = React.useCallback(
    () =>
      StagesService.getInternalApiStages(
        workflowId,
        perPage,
        true,
        query,
        clonable,
      ),
    [query, workflowId, perPage, clonable],
  );

  return useApiService(fetchStages);
}
